import { api } from "./client";

export type Period = "7d" | "30d" | "90d";

export type OverviewStats = {
  period: Period;
  event_count: number;
  active_users: number;
  total_cost_usd: number;
  input_tokens: number;
  output_tokens: number;
  error_count: number;
  web_chat_conversations: number;
  web_chat_users: number;
  web_chat_turns: number;
};

export type TrendPoint = {
  bucket: string;
  count: number;
  cost_usd: number;
};

export const overviewApi = {
  stats: (period: Period) => api.get<OverviewStats>(`/overview/stats?period=${period}`),
  trend: (period: Period, granularity: "day" | "hour" = "day") =>
    api.get<TrendPoint[]>(`/overview/trend?period=${period}&granularity=${granularity}`),
};
